import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

import {
  MobileHeaderBackButton,
  MobileHeaderBar,
  MobileHeaderForwardButton,
  MobileHeaderContent,
  MobileHeaderTitle,
  MobileHeaderTrailing,
} from './MobileHeader.style';

type MobileHeaderProps = {
  title?: ReactNode;
  onBack?: () => void;
  onForward?: () => void;
  children?: ReactNode;
};

export default function MobileHeader({ title, onBack, onForward, children }: MobileHeaderProps) {
  const { t } = useTranslation();

  return (
    <>
      <MobileHeaderBar>
        {onBack && (
          <MobileHeaderBackButton aria-label={t('mobileHeader.back')} data-qa-element-id="back_button" onClick={onBack}>
            <ArrowBack />
          </MobileHeaderBackButton>
        )}
        <MobileHeaderTitle>{title}</MobileHeaderTitle>
        {onForward && (
          <MobileHeaderTrailing>
            <MobileHeaderForwardButton
              aria-label={t('mobileHeader.forward')}
              data-qa-element-id="forward_button"
              onClick={onForward}
            >
              <ArrowForward />
            </MobileHeaderForwardButton>
          </MobileHeaderTrailing>
        )}
      </MobileHeaderBar>
      {children && <MobileHeaderContent>{children}</MobileHeaderContent>}
    </>
  );
}
